import axios from 'axios';
import { API_UPLOAD } from '../redux/apiRoutes';
import { toast } from 'react-toastify';

export const uploadFile = async (file, type = 'file') => {
  try {
    const formData = new FormData();
    formData.append(type, file);

    const response = await axios.post(`${API_UPLOAD}/${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data.success) {
      return response.data.data.url;
    } else {
      throw new Error('Upload failed');
    }
  } catch (error) {
    console.error('Upload error:', error);
    toast.error(`Error al subir el archivo: ${error.message}`, {
      position: 'bottom-right',
      style: { color: 'white' }
    });
    throw error;
  }
};

export const uploadImage = async (file) => {
  return uploadFile(file, 'image');
};

export const uploadDocument = async (file) => {
  return uploadFile(file, 'document');
};

export const deleteFile = async (filename) => {
  try {
    const response = await axios.delete(`${API_UPLOAD}/file/${filename}`);
    
    if (response.data.success) {
      return true;
    } else {
      throw new Error('Delete failed');
    }
  } catch (error) {
    console.error('Delete error:', error);
    toast.error(`Error al eliminar el archivo: ${error.message}`, {
      position: 'bottom-right',
      style: { color: 'white' }
    });
    throw error;
  }
};

export const extractFilenameFromUrl = (url) => {
  if (!url) return null;
  try {
    const urlParts = url.split('/');
    return urlParts[urlParts.length - 1];
  } catch (error) {
    console.error('Error extracting filename:', error);
    return null;
  }
}; 